export const initialUsersLogTable = {
    data: [],
    loading: false
}